const State = {

    // FIELDS
    "name": "Pangalan",
    "status": "Katayuan",
    "search": "Maghanap",
    "country": "Bansa",

    // PAGE HEADER
    "state": "Estado",

    // ERROR
    "error_name": "Ilagay ang Pangalan",
    "error_country": "Piliin ang Bansa",
    "error_status": "Piliin ang Katayuan",

    // TABLE HEADER
    "table_name": "PANGALAN",
    "table_country": "BANSA",
    "table_status": "KATAYUAN",

}

export default State;
